var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('landing-layout',[_c('template',{slot:"layout-left"},[_c('welcome-slogan')],1),_c('template',{slot:"layout-right"},[_c('login-form',{attrs:{"on-submit":_vm.submit,"errors":_vm.errors,"is-loading":_vm.isLoading}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }